import React, { useImperativeHandle, useRef, forwardRef } from 'react';
import classnames from 'classnames';

import { Container, Row, Col, Text } from '../../designSystem';

import styles from './Section.module.scss';

type PropsType = {
  id?: string;
  children: any;
  customClass?: string;
  sectionTitle?: string;
  title?: string;
  description?: any;
};

function Section(
  { id, sectionTitle, title, description, customClass, children }: PropsType,
  forwardedRef: any
) {
  const ref = useRef<HTMLElement>(null);
  let sectionTitleClass = '';
  let titleClass = '';
  let descriptionClass = '';

  const sectionClass = classnames(styles.section, {
    [`${customClass}`]: customClass,
  });

  if (!!sectionTitle) {
    sectionTitleClass = styles.section_row_section;
  }
  if (!!title && !description) {
    titleClass = styles.section_row_title;
  }
  if (!!title && !!description) {
    titleClass = styles.section_row_title_description;
    descriptionClass = styles.section_row_description;
  }

  useImperativeHandle(forwardedRef, () => ref.current);

  return (
    <section ref={ref} id={id} className={sectionClass}>
      {(!!sectionTitle || !!title || !!description) && (
        <Container>
          {!!sectionTitle && (
            <Row justify="center" className={sectionTitleClass}>
              <Col>
                <Text customClass={styles.section_section} text={sectionTitle?.toUpperCase()} />
              </Col>
            </Row>
          )}
          {!!title && (
            <Row justify="center" className={titleClass}>
              <Col>
                <Text customClass={styles.section_title} text={title} />
              </Col>
            </Row>
          )}
          {!!description && (
            <Row justify="center" className={descriptionClass}>
              <Col sm={12} md={10} lg={10}>
                <Text customClass={styles.section_description} text={description} />
              </Col>
            </Row>
          )}
        </Container>
      )}
      {children}
    </section>
  );
}

export default forwardRef(Section);
